import React from "react";
import { Brain, Trash2, Lightbulb, Gavel } from "lucide-react";
import ServerStatusCard from "./ServerStatusCard";

interface BrainTabProps {
  brain: any | null;
}

export default function BrainTab({ brain }: BrainTabProps) {
  const brainDailyNext = brain?.timers?.serverbrain_daily?.next;
  const brainPruneNext = brain?.timers?.brain_prune?.next;
  const facts = brain?.recent?.facts ?? [];
  const decisions = brain?.recent?.decisions ?? [];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <ServerStatusCard
          title="Brain Daily"
          value={brain?.latest?.daily ? "OK" : "N/A"}
          icon={Brain}
          subtitle={brainDailyNext ? `Next: ${brainDailyNext}` : undefined}
        />
        <ServerStatusCard
          title="Brain Prune"
          value={brain?.timers?.brain_prune?.next ? "scheduled" : "N/A"}
          icon={Trash2}
          subtitle={brainPruneNext ? `Next: ${brainPruneNext}` : undefined}
        />
      </div>

      <section>
        <h3 className="text-lg mb-3 flex items-center gap-2 text-foreground/80">
          <Lightbulb className="h-4 w-4" />
          Top Facts
        </h3>
        <div className="rounded-lg border border-primary/20 bg-black/30 p-4 space-y-2">
          {facts.length === 0 ? (
            <p className="text-muted-foreground text-sm">Nema podataka</p>
          ) : (
            facts.slice(0, 5).map((f: any) => (
              <div key={f.id} className="text-sm">
                <span className="text-foreground">{f.fact}</span>
                {f.confidence && (
                  <span className="text-muted-foreground ml-2">({f.confidence})</span>
                )}
              </div>
            ))
          )}
        </div>
      </section>

      <section>
        <h3 className="text-lg mb-3 flex items-center gap-2 text-foreground/80">
          <Gavel className="h-4 w-4" />
          Recent Decisions
        </h3>
        <div className="rounded-lg border border-primary/20 bg-black/30 p-4 space-y-2">
          {decisions.length === 0 ? (
            <p className="text-muted-foreground text-sm">Nema podataka</p>
          ) : (
            decisions.slice(0, 5).map((d: any) => (
              <div key={d.id} className="text-sm">
                <span className="text-foreground">{d.decision}</span>
                {d.rationale && (
                  <p className="text-muted-foreground text-xs mt-0.5">{d.rationale}</p>
                )}
              </div>
            ))
          )}
        </div>
      </section>
    </div>
  );
}
